import t from "@ext/localization/locale/translate";
import Property from "@ext/properties/components/Property";
import type { Property as PropertyType } from "@ext/properties/models";

export const PropertyValueTags = ({ property }: { property: PropertyType }) => {
	if (!property.value?.length)
		return <span className="pointer-events-none text-muted-foreground">{t("properties.empty")}</span>;

	return (
		<div className="pointer-events-none flex min-w-0 flex-wrap gap-1 py-0.5">
			{property.value.map((value) => (
				<Property
					key={value}
					maxWidth="100%"
					name={property.name}
					propertyStyle={property.style}
					size="sm"
					type={property.type}
					value={value}
				/>
			))}
		</div>
	);
};
